function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import React, { PureComponent } from 'react';
import classNames from 'classnames';
import { getDateString } from '../utils';
import format from 'date-fns/format';
import getDay from 'date-fns/get_day';
import isSameYear from 'date-fns/is_same_year';
var styles = {
  "rows": "Cal__Month__rows",
  "row": "Cal__Month__row",
  "partial": "Cal__Month__partial",
  "label": "Cal__Month__label",
  "partialFirstRow": "Cal__Month__partialFirstRow"
};

var Month = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(Month, _PureComponent);

  function Month() {
    return _PureComponent.apply(this, arguments) || this;
  }

  var _proto = Month.prototype;

  _proto.renderRows = function renderRows() {
    var _this$props = this.props,
        DayComponent = _this$props.DayComponent,
        disabledDates = _this$props.disabledDates,
        disabledDays = _this$props.disabledDays,
        monthDate = _this$props.monthDate,
        locale = _this$props.locale,
        maxDate = _this$props.maxDate,
        minDate = _this$props.minDate,
        rowHeight = _this$props.rowHeight,
        rows = _this$props.rows,
        selected = _this$props.selected,
        today = _this$props.today,
        theme = _this$props.theme,
        passThrough = _this$props.passThrough;
    var currentYear = today.getFullYear();
    var year = monthDate.getFullYear();
    var month = monthDate.getMonth();
    var monthShort = format(monthDate, 'MMM', {
      locale: locale.locale
    });
    var monthRows = [];
    var day = 0;
    var isDisabled = false;
    var isToday = false;
    var date, days, dow, row; // Used for faster comparisons

    var _today = format(today, 'YYYY-MM-DD');

    var _minDate = format(minDate, 'YYYY-MM-DD');

    var _maxDate = format(maxDate, 'YYYY-MM-DD'); // Oh the things we do in the name of performance...


    for (var i = 0, len = rows.length; i < len; i++) {
      var _classNames;

      row = rows[i];
      days = [];
      dow = getDay(new Date(year, month, row[0]));

      for (var k = 0, _len = row.length; k < _len; k++) {
        day = row[k];
        date = getDateString(year, month, day);
        isToday = date === _today;
        isDisabled = minDate && date < _minDate || maxDate && date > _maxDate || disabledDays && disabledDays.length && disabledDays.indexOf(dow) !== -1 || disabledDates && disabledDates.length && disabledDates.indexOf(date) !== -1;
        days[k] = /*#__PURE__*/React.createElement(DayComponent, _extends({
          key: "day-" + day,
          currentYear: currentYear,
          date: date,
          day: day,
          selected: selected,
          isDisabled: isDisabled,
          isToday: isToday,
          locale: locale,
          month: month,
          monthShort: monthShort,
          theme: theme,
          year: year,
          dayOfWeek: dow
        }, passThrough.Day));
        dow += 1;
      }

      monthRows[i] = /*#__PURE__*/React.createElement("ul", {
        key: "Row-" + i,
        className: classNames(styles.row, (_classNames = {}, _classNames[styles.partial] = row.length !== 7, _classNames)),
        style: {
          height: rowHeight
        },
        role: "row",
        "aria-label": "Week " + (i + 1)
      }, days);
    }

    return monthRows;
  };

  _proto.render = function render() {
    var _classNames2;

    var _this$props2 = this.props,
        locale = _this$props2.locale.locale,
        monthDate = _this$props2.monthDate,
        today = _this$props2.today,
        rows = _this$props2.rows,
        rowHeight = _this$props2.rowHeight,
        showOverlay = _this$props2.showOverlay,
        style = _this$props2.style,
        theme = _this$props2.theme;
    var dateFormat = isSameYear(monthDate, today) ? 'MMMM' : 'MMMM YYYY';
    return /*#__PURE__*/React.createElement("div", {
      style: _extends({}, style, {
        lineHeight: rowHeight + "px",
        paddingBlock: '8px'
      })
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: '18px',
        color: '#3a3838',
        lineHeight: '33px',
        margin: 0,
        textAlign: 'center'
      }
    }, format(monthDate, 'MMMM YYYY', {
      locale: locale
    })), /*#__PURE__*/React.createElement("div", {
      className: styles.rows
    }, this.renderRows(), showOverlay && /*#__PURE__*/React.createElement("label", {
      className: classNames(styles.label, (_classNames2 = {}, _classNames2[styles.partialFirstRow] = rows[0].length !== 7, _classNames2)),
      style: {
        backgroundColor: theme.overlayColor
      }
    }, /*#__PURE__*/React.createElement("span", null, format(monthDate, dateFormat, {
      locale: locale
    })))));
  };

  return Month;
}(PureComponent);

export { Month as default };